// Utility to resolve Tailwind screens
export const resolveTailwindScreens = (): Record<string, string> => {
  return {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  };
};
